import React from 'react';
import { useMediaQuery } from '@mui/system';
import HeaderSectionMobile from 'src/components/VehicleTrackingDetails/HeaderSection/HeaderSectionMobile';
import HeaderSectionDesktop from 'src/components/VehicleTrackingDetails/HeaderSection/HeaderSectionDesktop';

export default function HeaderSectionWrapper({
  toggleAddVehicleContentDrawer,
  openCreateLoadTab,
  toggleTargetVsActualForm,
  toggleGrnDrawer,
}) {
  const isMobile = useMediaQuery('(max-width: 600px)');

  return isMobile ? (
    <HeaderSectionMobile
      toggleAddVehicleContentDrawer={toggleAddVehicleContentDrawer}
      openCreateLoadTab={openCreateLoadTab}
      toggleTargetVsActualForm={toggleTargetVsActualForm}
      toggleGrnDrawer={toggleGrnDrawer}
    />
  ) : (
    <HeaderSectionDesktop
      toggleAddVehicleContentDrawer={toggleAddVehicleContentDrawer}
      openCreateLoadTab={openCreateLoadTab}
      toggleTargetVsActualForm={toggleTargetVsActualForm}
      toggleGrnDrawer={toggleGrnDrawer}
    />
  );
}
